var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:bevel;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-actions-close-simple"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.36,
    y1: 18.36,
    x2: 5.64,
    y2: 5.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.36,
    y1: 5.64,
    x2: 5.64,
    y2: 18.36
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSimple);
export default __webpack_public_path__ + "static/media/close-simple.db225dc9.svg";
export { ForwardRef as ReactComponent };